// Create a random number to use as a unique id when creating new entities
export const randomNumber = () =>
  Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
